import { SET_FORM, FETCH_BANKS, SET_STATE } from './types';
import { formatDate, formatAmount  } from '../../Common/utils';

const initialState = {
  form: {
    barcode: "",
    description: "",
    dueDate: "",
    bank: "",
    amount: "",
    protocol: ""
  },
  form2: false,
  redirect: false,
  supported: true,
  banks: []
}

export function ZwalletPaymentReducer(state=initialState, action) {
  let payload;
  switch(action.type) {
    case SET_FORM:
      payload = action.payload;

      return {
        ...state,
        form: {
          barcode: payload.barcode,
          description: payload.description,
          dueDate: formatDate(payload.dueDate),
          bank: payload.bank,
          amount: formatAmount(payload.amount),
          protocol: payload.protocol
        }
      }

    case FETCH_BANKS:
      payload = action.payload;

      return {
          ...state,
          banks: [...payload]
      }

    case SET_STATE:
      payload = action.payload;
      const { form2, redirect, supported } = payload;

      return {
        ...state,
        form2: form2,
        redirect: redirect,
        supported: supported
      }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/reducer.js